<template>
    <router-link :to="`/Article?articleId=${article.id}`" class="article-card">
        <div class="article-card__media">
            <img
                v-if="imageSrc && !imageFailed"
                :src="imageSrc"
                :alt="article.title"
                loading="lazy"
                @error="imageFailed = true"
            >
            <div v-else class="article-card__placeholder">
                <img :src="require('@/assets/LOGOPARON 2023.svg')" alt="">
            </div>
            <span v-if="date" class="article-card__date">{{ date }}</span>
        </div>
        <div class="article-card__body">
            <h3 class="article-card__title">{{ article.title }}</h3>
        </div>
        <div class="article-card__footer">
            <span>Διαβάστε</span>
            <v-icon small color="#ad282d">mdi-arrow-right</v-icon>
        </div>
    </router-link>
</template>

<script>
import restApi from '@/rest-api'
import { formatAthensDate } from '@/utils/date'

export default {
    name: 'ArticleCard',
    props: {
        article: { type: Object, required: true }
    },
    data: () => ({
        imageFailed: false
    }),
    computed: {
        imageSrc() {
            return restApi.imageUrl(this.article.image)
        },
        date() {
            return formatAthensDate(this.article.createdAt)
        }
    },
    watch: {
        'article.id'() {
            this.imageFailed = false
        }
    }
}
</script>

<style scoped>
.article-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    border: 1px solid rgba(27, 47, 90, 0.12);
    border-radius: 14px;
    overflow: hidden;
    color: #1b2f5a !important;
    text-decoration: none;
    box-shadow: 0 1px 2px rgba(27, 47, 90, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.article-card:hover,
.article-card:focus-visible {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(27, 47, 90, 0.14);
}

.article-card__media {
    position: relative;
    aspect-ratio: 16 / 10;
    background: #eef1f7;
    overflow: hidden;
}

.article-card__media > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 25%;
    transition: transform 0.35s ease;
}

.article-card:hover .article-card__media > img {
    transform: scale(1.04);
}

.article-card__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: linear-gradient(135deg, #1b2f5a 0%, #2c4a86 100%);
}

.article-card__placeholder img {
    width: 72px;
    opacity: 0.85;
}

.article-card__date {
    position: absolute;
    left: 12px;
    bottom: 12px;
    padding: 3px 10px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
    color: #1b2f5a;
    font-size: 12px;
    font-weight: 600;
}

.article-card__body {
    flex: 1;
    padding: 16px 18px 6px;
}

.article-card__title {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    line-height: 1.35;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.article-card__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    padding: 8px 18px 14px;
    color: #ad282d;
    font-size: 14px;
    font-weight: 600;
}
</style>
